@if (!hidden) {
    <div class="header" (click)="toggle()">
        <div class="header-title">{{ title }}</div>
        @if (dismissable && expanded) {
            @if (isEpcotEnabled) {
                <span class="icon close-btn" (click)="dismiss($event)">{{ sitecore.globalMessages.Close }}</span>
            } @else {
                <span class="icon theme-ex" (click)="dismiss($event)"></span>
            }
        }
        @if (!expanded) {
            <span class="icon theme-down"></span>
        }
    </div>
    @if (expanded) {
        <ms-scroll-adapter size="medium" [scrollItems]="stories">
            <div class="story-list">
                @for (story of stories; track story.id) {
                    <ms-story-preview
                        [story]="story"
                        [priority]="story.id === storyWithImage"
                        [more]="viewTitle"
                        [stretch]="strech"
                        (open)="openStory(story)" />
                }
            </div>
        </ms-scroll-adapter>
    }
}
